import { IonRouterOutlet, IonTabBar, IonTabs } from '@ionic/react';
import { Redirect, Route } from 'react-router-dom';
import React, { useEffect, useRef } from 'react';
import LogIn from '../pages/LogIn';
import { useAuthentication } from '../authentication/authentication-hook';
import { useKeycloakFeatureFlag } from '../authentication/AuthenticationFeatureSwitch';
import { useServiceWorker } from '../contexts/useServiceWorker';

export default function PublicAppRoutes() {
  return (
    <IonTabs>
      <IonRouterOutlet>
        <Route path="/login" exact component={ LogIn }/>

        <Route render={ props => <RedirectToLogin { ...props } /> }/>
      </IonRouterOutlet>

      <IonTabBar slot="bottom" color="dteal" />
    </IonTabs>
  );
}

function RedirectToLogin({ location }) {
  // TODO: LEGACY AUTH: BEGIN Remove this block.
  const isPublicPath = location.pathname.startsWith('/login');
  const { useLegacy } = useKeycloakFeatureFlag();
  // TODO: LEGACY AUTH: END Remove this block.

  const { login } = useAuthentication();
  const { hasPendingUpdate } = useServiceWorker();

  const hasTriggered = useRef(false);

  const from = location.pathname + location.search + location.hash;

  useEffect(() => {
    if (useLegacy) {
      return;
    }

    if (isPublicPath || hasTriggered.current) {
      return;
    }

    // Hold the redirect to Keycloak while a service worker update is pending so
    // the update banner stays visible and the user can reload into the new
    // version first. Once the update is applied (or if there is none) the
    // redirect proceeds. This effect re-runs when hasPendingUpdate changes.
    if (hasPendingUpdate) {
      return;
    }

    hasTriggered.current = true;
    login({
      redirectUri: window.location.href,
    });
  }, [ useLegacy, isPublicPath, from, login, hasPendingUpdate ]);

  // TODO: LEGACY AUTH: BEGIN Remove this block.
  if (useLegacy) {
    if (isPublicPath) {
      return null;
    }

    return (
      <Redirect
        to={ {
          pathname: '/login',
          state: { from },
        } }
      />
    );
  }
  // TODO: LEGACY AUTH: END Remove this block.

  return null;
}
